import type React from "react";
import { LoadingUI } from "../../../components/Loading";
import { MatchingFormUI } from "./components/MatchingForm";
import { MatchingResult } from "./components/MatchingResult";
import type { MatchingResults } from "./index";

export interface MatchingPageProps {
  candidateInfo: string;
  matchingResults: MatchingResults | null;
  isLoading: boolean;
  onSearch: (candidateInfo: string) => void;
  onCandidateInfoChange: (candidateInfo: string) => void;
}

export const MatchingPage: React.FC<MatchingPageProps> = ({
  candidateInfo,
  matchingResults,
  isLoading,
  onSearch,
  onCandidateInfoChange,
}) => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold">人材マッチング</h1>
      </div>

      <div className="grid grid-cols-1 gap-8">
        <MatchingFormUI
          candidateInfo={candidateInfo}
          isLoading={isLoading}
          onSubmit={onSearch}
          onCandidateInfoChange={onCandidateInfoChange}
        />

        {isLoading && (
          <div className="flex flex-col items-center justify-center space-y-4 py-12">
            <LoadingUI type="Grid" color="#34495E" width={60} height={60} />
            <p className="text-base-content/80 text-sm">マッチング分析中...</p>
          </div>
        )}

        {!isLoading && matchingResults && (
          <MatchingResult
            results={matchingResults.matches}
            totalAnalyzed={matchingResults.totalMattersAnalyzed}
            candidateInfo={matchingResults.candidateInfo}
          />
        )}
      </div>
    </div>
  );
};

export default MatchingPage;
